import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledFormControl = styled(FormControl)({
    width: "100%",
    marginBottom: "15px",
    "& .MuiInputLabel-root": {
        fontSize: "11px",
        color: "#000",
        fontWeight: "500",
        position: "relative",
        marginBottom: "5px",
        textTransform: "uppercase",
        transform: "translate(0px, 0px) scale(1)",
        "&.Mui-focused": {
            color: "#1e1e1e",
        },
    },
    "& .MuiOutlinedInput-root": {
        fontSize: "13px",
        backgroundColor: "#fff",
        "& fieldset": {
            borderColor: "#e2e4e7",
        },
        "&:hover fieldset": {
            borderColor: "#007cba",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#007cba",
            borderWidth: "1px",
        },
    },
    "& .MuiSelect-select": {
        padding: "10px 15px",
    },
});

const StyledMenuItem = styled(MenuItem)({
    fontSize: "13px",
    padding: "10px 15px",
    minHeight: "32px",
    lineHeight: 1.2,
    "&:hover": {
        backgroundColor: "#f0f0f0",
    },
    "&.Mui-selected": {
        backgroundColor: "#e8f0fe",
        "&:hover": {
            backgroundColor: "#d9e7fd",
        },
    },
});

const CustomSelect = ({
    label,
    value,
    onChange,
    options,
    size = "small",
    ...props
}) => {
    return (
        <StyledFormControl>
            <InputLabel>{label}</InputLabel>
            <Select value={value} onChange={onChange} size={size} {...props}>
                {options.map((option) => (
                    <StyledMenuItem key={option.value} value={option.value}>
                        {option.label}
                    </StyledMenuItem>
                ))}
            </Select>
        </StyledFormControl>
    );
};

export default CustomSelect;
